import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import action from './action.js'
import field from './field.js'

export default contract({
  action: array([
    action
  ]),
  field: array([
    field
  ])
})
